import tealium from '../../tealium';
import { registerAnalyticsEventHandler } from '../registry';
import { IDataLayer } from '../../../types';

/*

TODO: This data needs to be audited:
1. it doesn't seem correct as event_category is the same for all events
2. ask answer event_action isn't consistent
3. integrate with apps/tenant_web/assets/js/controllers/power_reviews_controller.ts

currently triggered from power_reviews javascript in drupal, example:
aveda/themes/aveda_base/js/site/power_reviews.js


*/

const defaultData: IDataLayer = {
  reviewRead: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'review - read',
    event_label: null, // '<product name> - <product ID>'
  },

  reviewStart: {
    event_name: 'read_write_review',
    event_category: 'product_reviews',
    event_action: 'review_write_start',
    event_label: null, // <productID>
  },

  writeaReview: {
    event_name: 'read_write_review',
    event_category: 'product_reviews',
    event_action: 'review_write_submit',
    event_label: null, // <productID>
  },

  reviewSort: {
    event_name: 'read_write_review',
    event_category: 'product_reviews',
    event_action: null, // <Highest/Oldest>,
    event_label: null, // <productID>
  },

  rateReviews: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'review - helpful', // 'review - helpful - <thumbs up/down / flag this review>'
    event_label: null, // '<product name> - <product ID>'
  },

  searchReviews: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'review - search', // 'review - search - <search term>'
    event_label: null, // '<product name> - <product ID>'
  },

  filterReviews: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'review - filter', // 'review - filter - <Filter Name> | <Filter Selected comma separated>'
    event_label: null, // '<product name> - <product ID>'
  },

  questionAnswer: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - ask a question - end',
    event_label: null, // '<product name> - <product ID>'
  },

  questionAsk: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - read',
    event_label: null, // '<product name> - <product ID>'
  },

  questionAskSearch: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - ask a question - search', // 'ask answer - ask a question - search - <search term>'
    event_label: null, // '<product name> - <product ID>'
  },

  sortAnswers: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - sort', // 'ask answer - sort - <sort order selected>'
    event_label: null, // '<product name> - <product ID>'
  },

  rateAnswers: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - helpful', // 'ask answer - helpful - <thumbs up/down>'
    event_label: null, // '<product name> - <product ID>'
  },

  addAnswerStart: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - add an answer - start',
    event_label: null, // '<product name> - <product ID>'
  },

  addAnswerEnd: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - add an answer - end',
    event_label: null, // '<product name> - <product ID>'
  },

  showMoreAnswers: {
    event_name: 'read_write_review',
    event_category: 'product reviews / ask answer',
    event_action: 'ask answer - show more q&a',
    event_label: null, // '<product name> - <product ID>'
  },
};

function trackReviews(eventName: string, eventData: IDataLayer = {}) {
  /*eventData.event_label = tealium.dataLayer.formatProductEventLabel();
  // TODO: maybe we can unify what is being sent here from the initiator of this event
  eventData.event_action = `${defaultData[eventName].event_action} - ${
    eventData.event_action || eventData.sort_option || eventData.search_term || ''
  }`;
  tealium.evtLink({ ...defaultData[eventName], ...eventData });*/

  const dataLayer = tealium.dataLayer?.data || {};

  if (eventData && eventData?.review_prodid) {
    if (eventData && eventData?.review_sort) {
      eventData.event_action = 'review_sort_' + eventData.review_sort;
    }
    eventData.event_label = 'PROD' + eventData.review_prodid;
  } else if (dataLayer?.product_id) {
    eventData.event_label = dataLayer?.product_id;
  }

  tealium.evtLink({ ...defaultData[eventName], ...eventData });
}

Object.keys(defaultData).forEach((key) => {
  registerAnalyticsEventHandler(key, trackReviews);
});
